import Utils from "../lib/Utils";

export default class PagePressRelease {
    constructor() {
        Utils.distributeDecorations();
    }
}